import { useContext, useEffect } from 'react'
import { applicationConfiguration } from '../modules/shared'
import { environment } from '../../environments/environment'
import TagManager from 'react-gtm-module'
import { isInIframe, postIframeProductInteraction, pushGtmProductInteraction } from '../modules/shared/helpers'

/**
 * Base app init
 */
export function BaseInit(): null {
  const config = useContext(applicationConfiguration)

  // Initialize Google Tag Manager
  useEffect(() => {
    if (!config) {
      return
    }

    if (environment.production && config.googleTagManagerID && config.buildType === 'community') {
      TagManager.initialize({
        gtmId: config.googleTagManagerID,
      })

      // Fire one-time (non-iframed) product pageview event
      if (!isInIframe()) {
        pushGtmProductInteraction()
      }
    }
  }, [config.googleTagManagerID])

  // Initialize iframe-related functionality
  useEffect(() => {
    if (!config) {
      return
    }

    if (isInIframe() && config.ocm?.iframeLogoutUrl) {
      postIframeProductInteraction(config.ocm.iframeLogoutUrl)
    }
  }, [config.ocm?.iframeLogoutUrl])

  return null
}
